module.exports = __webpack_public_path__ + "static/bg-bfb392b8725c3807a3cfc9df86cdda12.png";